import { render, staticRenderFns } from "./SpecialitiesInformation.vue?vue&type=template&id=5ff5c9ba&scoped=true"
import script from "./SpecialitiesInformation.vue?vue&type=script&lang=js"
export * from "./SpecialitiesInformation.vue?vue&type=script&lang=js"
import style0 from "./SpecialitiesInformation.vue?vue&type=style&index=0&id=5ff5c9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5c9ba",
  null
  
)

export default component.exports